<template>
  <v-container
    fluid
    class="pa-0 ma-0"
  >
    <v-card
      flat
    >
      <v-card-title>
        My Subscriptions
      </v-card-title>
      <v-card-text>
        <v-badge
          v-for="sub in subscriptions"
          :key="sub.id"
          left
          offset-x="20"
          offset-y="15"
          :color="!sub.paused ? 'green' : 'grey'"
          :icon="!sub.paused ? 'mdi-check' : 'mdi-pause'"
        >
          <v-chip
            class="ma-1"
            close
            close-icon="mdi-cog"
            filter
            filter-icon="mdi-check"
            :input-value="sub.status=='active'"
            @click:close="changeSubscription(sub)"
          >
            {{ sub.description }}
          </v-chip>
        </v-badge>
      </v-card-text>
    </v-card>
    <make-changes
      :show="show"
      :paused="item.paused"
      @close="show = false"
      @pause="show = false; pauseSubscription()"
      @cancel="show = false; cancelSubscription()"
    />
  </v-container>
</template>

<script>
import MakeChanges from './MakeChanges'

export default {
  components: { MakeChanges },
  data(){
    return {
      show: false,
      customer: {},
      item: {}
    }
  },
  computed:{
    subscriptions(){return this.customer
      && this.customer.subscriptions
      && this.customer.subscriptions.data
      && this.customer.subscriptions.data.map(sub=>{
        let {id, status, items, created, start_date, pause_collection} = sub
        let item = items.data[0]
        let plan = item.plan
        return {
          id, status, item, plan, created, start_date, sub, pause_collection,
          description: `${plan.amount * .01}/${plan.interval}`,
          price: item.price,
          paused: pause_collection
        }
      })
    }
  },
  mounted(){this.fetch()},
  methods:{
    async fetch(){
      const stripe = await this.api.get('/stripe/account')
      this.customer = stripe && stripe.customer || {}
    },
    changeSubscription(v){
      this.item = v
      this.show = true
    },
    async cancelSubscription(){
      await this.api.delete(`/stripe/subscription/${this.item.id}`)
      this.item = {}
      this.fetch()
    },
    async pauseSubscription(){
      await this.api.post(`/stripe/pause_subscription/${this.item.id}`)
      this.item = {}
      this.fetch()
    }
  }
}
</script>